// extracted by mini-css-extract-plugin
module.exports = {"StaffInfo":"staffInfo_StaffInfo__2o-lk","StaffInfo__gender":"staffInfo_StaffInfo__gender__1yuZT"};